"use strict";

exports.__esModule = true;
var _Heading = require("./Heading");
Object.keys(_Heading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Heading[key]) return;
  exports[key] = _Heading[key];
});